import React from 'react';
import theme, { styledTheme } from 'common/theme';
import Typography from 'components/Typography/Typography';
import { Button, Modal } from 'components';
import { ModalSize } from 'types';
import {
  OrderModalFooter,
  DetailTextLink,
  OrderFooterTextWrapper,
  ModalButtonsContainer,
  OrderModalBody,
  DetailTitleContainer
} from './NewSFOrdersTableStyled';
import FileViewer from 'common/components/FileViewer';
import { IcoDownload } from 'icons/indexed-icons/IcoDownload';
import { TFunction } from 'i18next';
interface ModalProps {
  showOrderDetails: boolean;
  hideOrderModal: () => void;
  downloadOrderDetails: () => void;
  fileUrl?: string;
  t: TFunction,
  isQuote?: boolean;
}
function DefaultHeader({ isQuote }: { isQuote?: boolean }) {
  return (
    <DetailTitleContainer>
      <Typography mb={0} weight="semi-bold" size="1.25rem">
       {isQuote ? 'Quote Details' : 'Order Details'}
      </Typography>
    </DetailTitleContainer>
  );
}
const OrderPdfModal = ({
  showOrderDetails,
  hideOrderModal,
  downloadOrderDetails,
  fileUrl,
  t,
  isQuote
}: ModalProps): JSX.Element => {
  return (
    <>
      <Modal
        onClose={hideOrderModal}
        size={ModalSize.SMALL}
        visible={showOrderDetails as boolean}
        allowContentScroll={true}
        closeBtnPos={{
          top: '1.7rem',
          right: '2rem'
        }}
      >
        <OrderModalBody>
          <div style={{ flex: 1, height: '100%' }}>
            <FileViewer headerComponent={() => <DefaultHeader isQuote={isQuote} />} height="100%" previewUrl={fileUrl} />
          </div>
        </OrderModalBody>
        <OrderModalFooter>
          <OrderFooterTextWrapper>
            <Typography color={theme.colors.grayDark} size="0.7rem">
              <DetailTextLink href="https://www.jbtc.com/privacy-and-cookie-policy/">
                Privacy Notice
              </DetailTextLink>{' '}
              &nbsp;and&nbsp;
              <DetailTextLink href="https://www.jbtc.com/terms-of-use/">
                Conditions of Use
              </DetailTextLink>
              . Unless otherwise noted, items sold by jbtc.com are subject to sales tax in select
              states in accordance with the applicable laws of that state. Learn more about tax and
              seller information.
            </Typography>
          </OrderFooterTextWrapper>
          <ModalButtonsContainer>
            <Button
              variant="text"
              width="8rem"
              onClick={downloadOrderDetails}
              color={styledTheme.JBTColors.mainColor}
              icon={<IcoDownload />}
            >
              {t('download_pdf', {ns: 'fpns'}) as string}
            </Button>
            <Button
              onClick={() => {
                hideOrderModal();
              }}
              bgColor={styledTheme.JBTColors.mainColor}
              height="2.5rem"
              variant="filled-primary"
            >
              {t('close') as string}
            </Button>
          </ModalButtonsContainer>
        </OrderModalFooter>
      </Modal>
    </>
  );
};
export default OrderPdfModal;
